import React, { createRef, useEffect, useState } from "react";
import styles from "./progressBar.module.scss";

export interface IProgressBarProps {
    value: number;
    max: number;
}

const ProgressBar: React.FunctionComponent<IProgressBarProps> = ({ value, max }) => {
    const ref: React.RefObject<HTMLDivElement> = createRef();
    const [width, setWidth] = useState(0);

    useEffect(() => setWidth(ref.current?.clientWidth ?? 0), [ref]);
    const valueWidth = (value / max) * width;

    return (
        <div className={styles.container} ref={ref}>
            <div className={styles.inner} style={{ maxWidth: valueWidth <= width ? valueWidth : width }}></div>
        </div>
    );
};

export default ProgressBar;
